import { render, staticRenderFns } from "./StatisticPopup.vue?vue&type=template&id=74efc5ab&scoped=true"
import script from "./StatisticPopup.vue?vue&type=script&lang=js"
export * from "./StatisticPopup.vue?vue&type=script&lang=js"
import style0 from "./StatisticPopup.vue?vue&type=style&index=0&id=74efc5ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efc5ab",
  null
  
)

export default component.exports